module.exports = __webpack_public_path__ + "static/media/competitors-no-data.a37b75b1.jpg";